export default __webpack_public_path__ + "static/media/Alchemy Chains 1.e9dc2f61.png";